
export type UserProfileResponseSocialLinks = {
  github?: string;
  linkedin?: string;
  twitter?: string;
};
